export default __webpack_public_path__ + "static/O0140-c6726f2ef00f52891c088f40ff805a4a.png";